export const getSchemaFilePath = (collectionId: string) =>
  `.schemas/${collectionId}.json`
